import './Code.css';
export var codeCSS = '_1v51izp0-3-12-1';